import { links } from "data";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";
import { AccordionLink } from "./accordion-link";

export const SUPPORT_ACCORDION_KEY = "SUPPORT_ACCORDION_KEY";

export const SupportAccordion = () => {
  return (
    <AccordionContainer accordionKey={SUPPORT_ACCORDION_KEY}>
      <div className="flex flex-column">
        <span className={styles.subtitle}>How can we help?</span>
        <AccordionLink href={links.CONTACT_US}>Contact us</AccordionLink>
        <AccordionLink href={links.REQUEST_AN_ONLINE_PROFILE}>
          Request an online profile
        </AccordionLink>
        <AccordionLink href={links.TRACK_YOUR_ITEMS}>
          Track your items
        </AccordionLink>
        <span className={styles.subtitle}>Guides & resources</span>
        <AccordionLink href={links.HOW_TO_PACKAGE_YOUR_ITEMS}>
          How to package your items
        </AccordionLink>
        <AccordionLink href={links.ALL_ESSENTIAL_RESOURCES}>
          All essential resources
        </AccordionLink>
        <span className={styles.subtitle}>Payments & guidance</span>
        <AccordionLink href={links.FUEL_SURCHARGES}>
          Fuel surcharges
        </AccordionLink>
        <AccordionLink href={links.UK_OVERNIGHT}>
          UK Overnight & International charges
        </AccordionLink>
        <AccordionLink href={links.PAYMENT_OPTIONS}>
          Payment options
        </AccordionLink>
      </div>
    </AccordionContainer>
  );
};
